export default __webpack_public_path__ + "img/mask-imac.8962f2e9.png";